import { types } from "../Actions/types";

const initialState = {
  tutoriallist: [],
  error: null,
  tutorialSingle: "",
  popupmodel: "",
};

const Tutorial = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.TUTORIAL_LIST:
      return {
        ...state,
        tutoriallist: payload,
        error,
      };
    case types.TUTORIAL_SINGLE:
      return {
        ...state,
        tutorialSingle: payload,
        error,
      };
    case types.TUTORIAL_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default Tutorial;
